(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[482],{

/***/ 98896:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/[slug]",
      function () {
        return __webpack_require__(74718);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19435:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/brakes.b89a9927.svg","height":65,"width":60});

/***/ }),

/***/ 92695:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/calendar-icon.a0c1c9de.svg","height":58,"width":54});

/***/ }),

/***/ 51198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/get-quote.706781f2.svg","height":59,"width":60});

/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 18132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z8": function() { return /* binding */ WarningSignsSoundsSection; }
/* harmony export */ });
/* unused harmony exports Warnings, Warning */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61275);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var _LandingPageButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17743);






var WarningSignsSoundsSection = function(param) {
    var title = param.title, subheading = param.subheading, formalMakeName = param.formalMakeName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: "24px",
                        fontWeight: 900
                    },
                    className: "jsx-bad3bc23d5561c1f",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "jsx-bad3bc23d5561c1f",
                    children: subheading
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "bad3bc23d5561c1f",
                    children: "p.jsx-bad3bc23d5561c1f{color:#f04e23;font-size:50px}"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warnings, {
                    formalMakeName: formalMakeName
                })
            ]
        })
    });
};
var Warnings = function(param) {
    var formalMakeName = param.formalMakeName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "grid md:grid-cols-3 gap-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Grinding, Screeching, Squealing, Rubbing, and Other High-Pitched Noises",
                description: "High-pitched noises during the braking process likely means you’re dealing with worn out brake pads and shoes. Continuing to drive with worn out pads and shoes can cause further damage to your vehicle if left unattended, so make sure to schedule a brake inspection ASAP."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Vibration or Pulsing",
                description: "If you feel vibrations or pulsing in the brake pedal or steering wheel during the process of braking, you’re probably dealing with rotor issues. Warped or damaged rotors can lead to a costly repair bill, so get your vehicle checked as soon as you start feeling the sensation."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Excessive Brake Pedal Travel",
                description: "If you feel like your pedal travels further than it should when pushing on the brakes, you’re likely feeling the beginning of brake pad issues. This is the ideal time to get your brakes inspected and repaired, as you’re less likely to have extensive damage."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Grinding, Screeching, Squealing, Rubbing, and Other High-Pitched Noises",
                description: "High-pitched noises during the braking process likely means you’re dealing with worn out brake pads and shoes. Continuing to drive with worn out pads and shoes can cause further damage to your vehicle if left unattended, so make sure to schedule a brake inspection ASAP."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Vibration or Pulsing",
                description: "If you feel vibrations or pulsing in the brake pedal or steering wheel during the process of braking, you’re probably dealing with rotor issues. Warped or damaged rotors can lead to a costly repair bill, so get your vehicle checked as soon as you start feeling the sensation."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Schedule A Free Brake Inspection & Estimate For Your ".concat(formalMakeName),
                showButton: true,
                description: "If you are experiencing any problematic symptoms, schedule a free inspection and estimate from our Dallas brake techs.",
                buttonText: "Free ".concat(formalMakeName, " Brake Service Estimate")
            })
        ]
    });
};
var Warning = function(param) {
    var warning = param.warning, description = param.description, showButton = param.showButton, buttonText = param.buttonText;
    var warningStyles = {
        padding: "20px 20px"
    };
    var orangeWarningStyles = {
        border: "1px solid #ead1ca",
        background: "#ffeee7"
    };
    var styles = showButton ? (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .mergeRight */ .ATH)(warningStyles, orangeWarningStyles) : warningStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: styles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                style: {
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "1.33",
                    color: "#1a1919"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: warning
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    color: "#818b92"
                },
                children: description
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageButton__WEBPACK_IMPORTED_MODULE_5__/* .LandingPageButton */ .K, {
                    buttonText: buttonText
                })
            })
        ]
    });
};


/***/ }),

/***/ 18737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ GraySection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var GraySection = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var baseClassName = "bg-gray-100";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, className)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ HappinessGuaranteeSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);





var HappinessGuaranteeSection = function(param) {
    var description = param.description, title = param.title, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#fff3f0" : _backgroundColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__/* .faShieldCheck */ .ip,
                    color: "#f04f23",
                    size: "7x"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "py-4 title",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description",
                    children: description
                })
            ]
        })
    });
};


/***/ }),

/***/ 55779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ HowItWorksSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);
/* harmony import */ var _LandingPageButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17743);






var HowItWorksSection = function(param) {
    var title = param.title, description = param.description, steps = param.steps, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: 40,
                        color: "black",
                        fontWeight: 700
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "pb-2",
                    style: {
                        color: "#7c7c7c"
                    },
                    children: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid md:grid-cols-3",
                    style: {
                        boxShadow: "0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)"
                    },
                    children: steps.map(function(value, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowItWorksStep, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, value), index);
                    })
                }),
                buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pt-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageButton__WEBPACK_IMPORTED_MODULE_4__/* .LandingPageButton */ .K, {
                        buttonText: buttonText
                    })
                })
            ]
        })
    });
};
var HowItWorksStep = function(param) {
    var title = param.title, description = param.description, image = param.image;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-grow flex-col h-100 px-5",
        style: {
            backgroundColor: "white",
            border: "1px solid rgb(220, 219, 219)",
            paddingTop: "75px",
            paddingBottom: "75px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: image,
                width: 60,
                height: 60,
                alt: title,
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        style: {
                            paddingTop: "20px",
                            fontSize: "18px",
                            fontWeight: 900
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "description m-0",
                        children: description
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 17743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LandingPageButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);








function LandingPageButton(props) {
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: "/get-quote/",
            query: query
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(props.className),
                style: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 25,
                    paddingRight: 25
                }
            }, props.buttonProps), {
                children: props.buttonText
            }))
        })
    });
}


/***/ }),

/***/ 74718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CarPostTemplate": function() { return /* binding */ CarPostTemplate; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/CarPage/FAQSection.tsx
var FAQSection = __webpack_require__(6550);
// EXTERNAL MODULE: ./src/components/CarPage/WarningSignsSoundsSection.tsx
var WarningSignsSoundsSection = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var GraySection = __webpack_require__(18737);
;// CONCATENATED MODULE: ./src/components/CarPage/SkipTheShopSection.tsx





var SkipTheShopSection = function(param) {
    var description = param.description, title = param.title, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                    buttonText: buttonText
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/CarPage/BetterServiceForLess.tsx




var BetterServiceForLess = function(param) {
    var description = param.description, title = param.title, formalModelName = param.formalModelName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "pt-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    borderBottom: "1px solid #818b92",
                    paddingBottom: "40px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description",
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m-4 md:mr-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard, {
                                    title: "Average ".concat(formalModelName, " Brake Pad Replacement Cost"),
                                    lowerPrice: 379,
                                    upperPrice: 429
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m-4 md:ml-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard, {
                                    title: "Average ".concat(formalModelName, " Brake Rotor Replacement Cost"),
                                    lowerPrice: 350,
                                    upperPrice: 490
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "description text-center pt-5",
                        children: [
                            "Average prices are just estimates. For accurate pricing, give us a call or submit an online quote request for your ",
                            formalModelName,
                            "."
                        ]
                    })
                ]
            })
        })
    });
};
var PricingCard = function(param) {
    var title = param.title, lowerPrice = param.lowerPrice, upperPrice = param.upperPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col flex-grow py-8 text-center",
        style: {
            backgroundColor: "white",
            boxShadow: "0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#818b92",
                    fontSize: 16
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                style: {
                    fontSize: 50,
                    fontWeight: 700,
                    color: "#565555"
                },
                children: [
                    "$",
                    lowerPrice,
                    "-$",
                    upperPrice
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#818b92",
                    fontSize: 16
                },
                children: "Includes Parts, Labor & Warranty"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/CarPage/WorkAroundYouSection.tsx





var WorkAroundYouSection = function(param) {
    var description = param.description, title = param.title, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-4",
                style: {
                    borderBottom: "1px solid #818b92",
                    paddingBottom: "40px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "title",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "description",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            alt: "NuBrakes Mobile Repair Works Around Your Schedule",
                            layout: "responsive",
                            width: 800,
                            height: 440
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
;// CONCATENATED MODULE: ./src/components/RelatedBlogPosts.tsx










var RelatedBlogPosts = function(param) {
    var posts = param.posts, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: (0,es/* pipe */.zGw)((0,es/* take */.qnb)(3), (0,util/* mapIndexed */.XD)(function(post, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostShortView, {
                                image: post.featured_image,
                                title: post.title,
                                slug: "".concat(post.slug),
                                date: post.published
                            })
                        }, index);
                    }))(posts)
                })
            ]
        })
    });
};
var BlogPostShortView = function(param) {
    var title = param.title, slug = param.slug, image = param.image, date = param.date;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/[slug]",
        as: {
            pathname: "/blog/".concat(slug, "/"),
            query: query
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col bg-white rounded h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: title,
                        layout: "responsive",
                        src: image,
                        height: 400,
                        width: 600,
                        className: "w-100 rounded-t"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 text-left flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-auto",
                                children: dayjs_min_default()(date).format("MMMM DD, YYYY")
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/LandingPage/TitleSection.tsx + 1 modules
var TitleSection = __webpack_require__(32158);
// EXTERNAL MODULE: ./src/components/FeatureBySection.tsx + 4 modules
var FeatureBySection = __webpack_require__(97257);
// EXTERNAL MODULE: ./src/components/LandingPage/HowItWorksSection.tsx
var HowItWorksSection = __webpack_require__(55779);
// EXTERNAL MODULE: ./src/components/HappinessGuaranteeSection.tsx
var HappinessGuaranteeSection = __webpack_require__(28763);
// EXTERNAL MODULE: ./public/img/nubrakes-logo-no-text.svg
var nubrakes_logo_no_text = __webpack_require__(5120);
;// CONCATENATED MODULE: ./src/components/LandingPage/BrakeRepairNearYouSection.tsx








var BrakeRepairNearYouSection = function(param) {
    var title = param.title, cities = param.cities, phoneNumberTxt = param.phoneNumberTxt, phoneNumber = param.phoneNumber, buttonText = param.buttonText;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: nubrakes_logo_no_text/* default */.Z,
                        alt: "NuBrakes Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title",
                    children: title
                }),
                cities && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "description",
                    children: [
                        "We bring the brake shop to you. Find the best",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: "/brake-repair-near-me",
                                query: query
                            },
                            children: " brake repair near you"
                        }),
                        " now."
                    ]
                }),
                phoneNumberTxt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "description",
                    children: [
                        "Call us at ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(phoneNumber),
                            children: phoneNumberTxt
                        }),
                        " to speak with a brake specialist or click the button below to receive a free, no-obligation quote."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-4",
                    children: cities && cities.map(function(city, cityIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            as: {
                                pathname: city.linkUrl,
                                query: query
                            },
                            href: "/cities/[slug",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    city.cityName,
                                    " Brake Repair"
                                ]
                            })
                        }, cityIndex);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        paddingTop: "5%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                        buttonText: buttonText ? buttonText : "Get A Free Brake Service Estimate"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./public/img/get-quote.svg
var get_quote = __webpack_require__(51198);
// EXTERNAL MODULE: ./public/img/calendar-icon.svg
var calendar_icon = __webpack_require__(92695);
// EXTERNAL MODULE: ./public/img/brakes.svg
var brakes = __webpack_require__(19435);
;// CONCATENATED MODULE: ./src/pages/cars/[slug].tsx




















var __N_SSG = true;
var CarPostTemplate = function(param) {
    var possessiveName = param.possessiveName, makeShortName = param.makeShortName, carImage = param.carImage, backgroundImage = param.backgroundImage, posts = param.posts, rating = param.rating, reviewCount = param.reviewCount;
    var formalShortName = (0,string_utils/* toNameUpper */.L)(makeShortName);
    var formalLongName = (0,string_utils/* toNameUpper */.L)(makeShortName);
    var formalPossesive = (0,string_utils/* toNameUpper */.L)(possessiveName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection/* TitleSection */.Q, {
                reviewCount: reviewCount,
                rating: rating,
                title: "Top-Rated, Affordable ".concat(formalShortName, " Brake Repair Services Delivered To You"),
                image: backgroundImage,
                callToActionButtonText: "Get a Free Brake Repair Estimate For Your ".concat(makeShortName),
                subheading: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Schedule top-rated ",
                        makeShortName,
                        " brake service from our mobile brake technicians at your office, home or apartment — all backed by our ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/warranty",
                            children: "NuBrakes Guarantee"
                        }),
                        " and crazy good customer service."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBySection/* FeatureBySection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksSection/* HowItWorksSection */.c, {
                title: "How Our Mobile ".concat(formalLongName, " Brake Service Works"),
                description: "The easiest way to service your ".concat(formalPossesive, " brakes for less"),
                steps: [
                    {
                        title: "Get Your Free Repair Quote",
                        description: "Let us know what’s going on with your brakes and we’ll send you a free, no obligation repair quote for your vehicle.",
                        image: get_quote/* default */.Z
                    },
                    {
                        title: "Select Your Repair Date",
                        description: "Select a repair date and time that works around your schedule. We pride ourselves on making it simple for you.",
                        image: calendar_icon/* default */.Z
                    },
                    {
                        title: "Enjoy Safer, Better Driving",
                        description: "Our brake technicians will ensure that your brakes are ready to hit the road and get you back to driving worry-free!",
                        image: brakes/* default */.Z
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkAroundYouSection, {
                title: "".concat(formalLongName, " Brake Repair That Works Around Your Schedule & Budget"),
                image: carImage,
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Driving a high-performance car like a ",
                        formalLongName,
                        " means ",
                        "you'll",
                        " want to keep its brakes maintained frequently, but with that comes unnecessary expenses. Our mobile brake technicians have over 15 years of experience handling ",
                        formalShortName,
                        " brakes and mechanical needs, so they know exactly how to service your",
                        formalShortName,
                        " and get it back on the road. Plus, all of our work is backed by our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/warranty",
                            children: "NuBrakes Guarantee"
                        }),
                        " to ensure your brakes perform as they should each and every day."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BetterServiceForLess, {
                title: "Better ".concat(formalShortName, " Brake Service For Less."),
                description: "Owning and maintaining a ".concat(formalShortName, " can be expensive, but there are ways to ensure that you're not on the losing end of a repair bill. At NuBrakes, we're transparent about our pricing and we try to provide all ").concat(formalShortName, " owners with the peace of mind that they're getting a fair and honest brake service price using premium parts that last. As with every brake service, our brake technicians will diagnose and replace brake pads, rotors and calipers only when absolutely necessary to the longevity and safety of your vehicle."),
                formalModelName: formalShortName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipTheShopSection, {
                title: "Skip The Shop, We Bring Top-Rated ".concat(formalShortName, " Brake Services To Your Work or Home."),
                description: "Stop searching for the best ".concat(formalShortName, " brake service near you and let it come to you. Our mobile ").concat(formalShortName, " brake service technicians provide top-rated, fully-warranted brake services for your ").concat(formalShortName, " right where you're parked at your office, home or apartment. Why waste half a day and pay more at the local brake shop or dealer when you could sit in the comfort of your office or home and receive premium ").concat(formalShortName, " brake service for less."),
                buttonText: "Get a Free Brake Repair Estimate For Your ".concat(formalShortName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningSignsSoundsSection/* WarningSignsSoundsSection */.Z8, {
                title: "".concat(formalShortName, " Brake Problems & Symptoms"),
                subheading: "Warning Signs & Sounds",
                formalMakeName: formalShortName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
                title: "We have a 100% NuBrakes Happiness Guarantee!",
                description: "We want to make the brake repair process simple and frustration-free. If you're not happy with your repair or replacement, we'll do everything we can to fix it. Call or message us any day, any time, and we'll do our best to fix whatever issue you're having."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {
                title: "Frequently Asked ".concat(formalShortName, " Brake Repair Questions"),
                description: "Learn more about our ".concat(formalShortName, " brake service."),
                faqs: [
                    {
                        question: "How is NuBrakes different from other ".concat(formalShortName, " brake repairs near me?"),
                        answer: "NuBrakes provides a modern approach to brake repair and replacements by providing an on-demand style service that comes to you. Unlike traditional ".concat(formalShortName, " brake service shops that require to you to wait in the lobby while the brake repair is being done, use poor quality parts, and lack transparent pricing; NuBrakes will start by sending you a transparent quote, upon your approval, a NuBrakes ASE-certified technician will come to you with everything they need to repair your brakes. We want to save you time and provide you with a trustworthy and transparent diagnosis and repair quote for your ").concat(formalShortName, ". To request a quote, simply click here, fill out your vehicle information and brake symptoms, and we’ll send you a quote for your ").concat(formalShortName, " brake service in under an hour.")
                    },
                    {
                        question: "Are your ".concat(formalShortName, " brake service technicians ASE-certified?"),
                        answer: "Absolutely. Every NuBrakes ".concat(formalShortName, " brake repair technician has years of industry experience and has been certified by The National Institute for Automotive Service Excellence (ASE). Our technicians have a depth of knowledge in all forms of vehicle repair, but brake repair is our core service and specialty.")
                    },
                    {
                        question: "Why should I choose mobile brake repair?",
                        answer: "We’re a firm believer that your time, energy, and a trustworthy service provider is much more valuable than spending your Saturday afternoon at the brake repair shop. We’ve built the NuBrakes service so that you can efficiently receive a quote and schedule a mobile brake repair service that comes to you, with just a few clicks. There’s not enough time in the day and we think you should spend more time doing what you love and waiting at the brake repair shop is not it. Not to mention, many brake repair shops will quote you more than you need to spend, and often suggest you repair or replace brake parts when it is not necessary. What’s better than saving time and money?"
                    },
                    {
                        question: "What type of brake pads does NuBrakes use?",
                        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "High-quality parts are of the utmost importance when repairing your brakes. At NuBrakes, most frequently we are using professional ceramic or semi-metallic brake pads. These parts offer exceptional performance and are backed by our ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/warranty",
                                    children: "NuBrakes Guarantee"
                                }),
                                "."
                            ]
                        })
                    },
                    {
                        question: "How long does it take to repair or replace my brakes?",
                        answer: "On average, your mobile brake repair service will take 45-90 minutes, with the average appointment lasting around an hour. If you have any time constraints, we’re happy to coordinate around your schedule."
                    },
                    {
                        question: "What should I expect during my brake repair appointment?",
                        answer: "After you request a free brake repair quote, you’ll receive an email within 1 hour that will outline our best guess (based on the symptoms you provided) for the repairs and estimated cost. On the day of your appointment, a NuBrakes technician will arrive with all the tools they need to evaluate your brakes in person. Following the in-person evaluation, your technician will provide you with a formal repair quote. Upon your approval, the technician will complete the brake repair procedure."
                    },
                    {
                        question: "Do you service all ".concat(formalShortName, " models?"),
                        answer: "Yes, we’re able to provide brake service on nearly all ".concat(formalShortName, " models and trims! All of our mobile brake replacement technicians have all of the necessary tools and experience to repair your brakes no matter the model/year. So whether you’re looking for service on a 328i or an M-class, we can take care of your brake service needs.")
                    },
                    {
                        question: "Do you offer a warranty on the brake repairs?",
                        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Yes, your NuBrakes mobile brake repair is backed by our",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/warranty",
                                    children: "NuBrakes Guarantee"
                                }),
                                "."
                            ]
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedBlogPosts, {
                posts: posts,
                title: "".concat(formalShortName, " Brake Repair Service Posts & News"),
                description: "Everything ".concat(formalShortName, " & Brakes.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrakeRepairNearYouSection, {
                title: "We’re the closest ".concat(formalShortName, " brake service near you. Skip waiting in line at the repair shop, we come to you!"),
                cities: [
                    {
                        cityName: "Austin, TX",
                        linkUrl: "/cities/austin-brake-repair"
                    },
                    {
                        cityName: "San Antonio, TX",
                        linkUrl: "/cities/san-antonio-brake-repair"
                    },
                    {
                        cityName: "Forth Worth, TX",
                        linkUrl: "/cities/fort-worth-brake-repair"
                    },
                    {
                        cityName: "Dallas, TX",
                        linkUrl: "/cities/dallas-brake-repair"
                    },
                    {
                        cityName: "League City, TX",
                        linkUrl: "/cities/league-city-brake-repair"
                    },
                    {
                        cityName: "Houston, TX",
                        linkUrl: "/cities/houston-brake-repair"
                    },
                    {
                        cityName: "Pflugerville, TX",
                        linkUrl: "/cities/pflugerville-brake-repair"
                    },
                    {
                        cityName: "Atlanta, GA",
                        linkUrl: "/cities/atlanta-brake-repair"
                    },
                    {
                        cityName: "Nashville, TN",
                        linkUrl: "/cities/nashville-brake-repair"
                    },
                    {
                        cityName: "Tampa, FL",
                        linkUrl: "/cities/tampa-brake-repair"
                    },
                    {
                        cityName: "Orlando, FL",
                        linkUrl: "/cities/orlando-brake-repair"
                    },
                    {
                        cityName: "Jacksonville, FL",
                        linkUrl: "/cities/jacksonville-brake-repair"
                    },
                    {
                        cityName: "Miami, FL",
                        linkUrl: "/cities/miami-brake-repair"
                    },
                    {
                        cityName: "Chicago, IL",
                        linkUrl: "/cities/chicago-brake-repair"
                    }, 
                ]
            })
        ]
    });
};
var CarsPost = function(param) {
    var car = param.car, posts = param.posts, reviewCount = param.reviewCount, rating = param.rating;
    var possessiveName = car.possessiveName, makeShortName = car.makeShortName, tags = car.tags, carImage = car.carImage, backgroundImage = car.backgroundImage, modelList = car.modelList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "".concat((0,string_utils/* toNameUpper */.L)(makeShortName), " Brake Repair - NuBrakes"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Schedule brake repair services for your ".concat((0,string_utils/* toNameUpper */.L)(makeShortName), " from NuBrakes")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarPostTemplate, {
                backgroundImage: backgroundImage,
                carImage: carImage,
                rating: rating,
                reviewCount: reviewCount,
                makeShortName: makeShortName,
                possessiveName: possessiveName,
                modelList: modelList,
                tags: tags,
                posts: posts
            })
        ]
    });
};
/* harmony default export */ var _slug_ = (CarsPost);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,7948,2978,6907,2932,9435,9774,2888,179], function() { return __webpack_exec__(98896); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);